import { ethers } from "ethers";
import { getWeb3 } from "./connectors";
import lpAbi from '../json/lpabi.json';
import nftAbi from '../json/nft.json';
import daoAbi from '../json/daoAbi.json';
import daorewardAbi from '../json/daoreward.json';
import daorewardEthAbi from '../json/daorewardeth.json';
import { contract, DAO_REWARD } from "./constant";
import { DEFAULT_CHAIN } from "./constant";
import axios from "axios";
import { MulticallContractWeb3 } from "./useContracts";
import { supportNetwork } from "./network";




export const getContract = (abi, address, library) => {
  try {
    return new ethers.Contract(address, abi, library)
  }
  catch {
    return false;
  }
}

export const formatPrice = (num , decimals = 8) => {
  //return parseFloat(num.toFixed(decimals)).toLocaleString();
  return new Intl.NumberFormat('en-US' , {maximumSignificantDigits : decimals}).format(parseFloat(num).toFixed(18));
}


export const getWeb3Contract = (abi, address , rpc=supportNetwork[DEFAULT_CHAIN].rpc) => {
  let web3 = getWeb3(rpc);
  return new web3.eth.Contract(abi, address);
}

export const getLpContract = (addrsess) => {
  let web3 = getWeb3();
  return new web3.eth.Contract(lpAbi, addrsess);
}

export const getNFTContract = (nftaddress = '') => {
  let web3 = getWeb3();
  return new web3.eth.Contract(nftAbi, nftaddress);
}

export const getDaoContract = () => {
  let web3 = getWeb3();
  return new web3.eth.Contract(daoAbi, contract[DEFAULT_CHAIN].DAO_ADDRESS);
}

export const getDaoRewardContract = (chainId = DEFAULT_CHAIN, rpc = supportNetwork[DEFAULT_CHAIN].rpc) => {
  let web3 = getWeb3(rpc);
  return new web3.eth.Contract(daorewardAbi, DAO_REWARD[chainId].DAO_REWARD_ADDRESS);
}

export const getDaoRewardETHContract = (chainId = DEFAULT_CHAIN, rpc = supportNetwork[DEFAULT_CHAIN].rpc) => {
  let web3 = getWeb3(rpc);
  return new web3.eth.Contract(daorewardEthAbi, DAO_REWARD[chainId].DAO_REWARD_ADDRESS);
}


export const getAllNFTDetails = async () => {

  let userNftData = [];

  return userNftData;
}


export const getHolderVotingPower = async (hoderlist = []) => {
  let userVotingPower = [];
  let daoContract = getDaoContract();
  let error = 'OK';
  let count = 1;

  const holderChunk = hoderlist.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / 100)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, []);


  async function* fetchData() {
    let i = 0;
    while (i < holderChunk.length) {
      let callArray = [];

      callArray = holderChunk[i].map((value) => {
        return daoContract.methods.getVotingWeight(value);
      });

      try {
        let nftData = await MulticallContractWeb3(callArray);
        let addressWithPower = [];

        // eslint-disable-next-line
        await holderChunk[i].map((rowdata, index) => {
          addressWithPower[index] = { id: count, address: rowdata, power: nftData[index] };
          count++;
          return true;
        })
        yield { error: 'OK', data: addressWithPower };

      } catch (err) {
        yield { 'error': err.message };
        break;
      }
      i++;
    }

  }

  for await (const nftData of fetchData()) {
    if (nftData.error === 'OK' && nftData.data) {
      userVotingPower = userVotingPower.concat(nftData.data);
    }
    else {
      userVotingPower = [];
      error = nftData.error;
    }


  }

  return { userVotingPower, error };
}

export const getWalletNFTDetails = async (walletAddress = '', nftaddress = '' , limit = 10) => {
  if (nftaddress) {
    let userNftData = [];
    let response = ''
    if(walletAddress){
      response = await axios.get(`https://nftapp.blockstar.kids/api/nft?nft_address=${nftaddress}&owner=${walletAddress}&limit=${limit}`);
    }
    else{
      response = await axios.get(`https://nftapp.blockstar.kids/api/nft?nft_address=${nftaddress}&limit=${limit}`);
    }
    
    if (response && response.status === 200 && response.data) {
      userNftData = response.data;
    }
    return userNftData;
  }
  else {
    return false;
  }

}


export const uploadToIPFS = async (metadata) => {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  try {
    const response = await axios.post(
      url,
      metadata,
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
        },
      }
    );

    return response.data.IpfsHash; // Contains IPFS hash and other info
  } catch (error) {
    console.error("Error uploading to IPFS: ", error);
    return false;
  }
};


export const uploadImageToIPFS = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const url = `https://api.pinata.cloud/pinning/pinFileToIPFS`;
    const options = {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
        'Content-Type': 'multipart/form-data',
      },
    };


    const response = await axios.post(url, formData, options);
    if (response.status !== 200) return false;
    return response.data.IpfsHash;
  } catch (error) {
    console.error('Error uploading image:', error);
    return false;
  }
};

